import { render } from "./designPeoplePreview.vue?vue&type=template&id=6d367fb5"
import script from "./designPeoplePreview.vue?vue&type=script&lang=js"
export * from "./designPeoplePreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__